<template>
  <service-category>

    <layout-header-title slot="header" title="서비스 공통 정책"/>

    <div class="category" slot="category">

      <layout-two-column title="최대 주문 건수">

        <layout-input v-model="editable.pickupOrderLimit"
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

      <p class="info">최대 주문 건수를 설정해주세요. ex) 5 (최대 주문 5개)</p>

      <layout-two-column title="주문 당 아이템 최대 수량">

        <layout-input v-model="editable.pickupOrderItemsLimit"
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

      <p class="info">주문 당 아이템 최대 수량을 설정해주세요. ex) 5 (최대 주문 가능한 수량 5개)</p>

      <layout-two-column title="품절 기준">

        <layout-input v-model="editable.soldOutLimit"
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

      <p class="info">품절 기준 (sold out)을 설정해주세요.. ex) 5 (5개 상품이 남으면 마감)</p>

      <layout-two-column title="주문 임박 표시 갯수">

        <layout-input v-model="editable.orderSoonLimit"
                      type="number"
                      class="input"
                      :regex="regex(0, 100).num"/>

      </layout-two-column>

      <p class="info">주문 임박 표시 갯수 (order soon)를 설정해주세요.. <br/>ex) 5 (품절 임박 제한 갯수가 5면 5 + 5 해서 10개 남으면 주문 마감 임박)</p>

    </div>

  </service-category>
</template>

<script>
import { regex } from '@/utils/utils';

import LayoutHeaderTitle from '@/spa/components/LayoutHeaderTitle';
import LayoutInput from '@/spa/components/LayoutInput';

import LayoutTwoColumn from '../LayoutTwoColumn';
import ServiceCategory from '../ServiceCategory';

export default {
  name: 'CommonServicePolicy',
  props: {
    pickupOrderLimit: Number,
    pickupOrderItemsLimit: Number,
    soldOutLimit: Number,
    orderSoonLimit: Number,
  },
  components: {
    ServiceCategory,

    LayoutTwoColumn,
    LayoutHeaderTitle,
    LayoutInput,
  },
  watch: {
    'editable.pickupOrderLimit': {
      deep: true,
      handler(value) {
        this.$emit('onChangePickupOrderList', value);
      },
    },
    'editable.pickupOrderItemsLimit': {
      deep: true,
      handler(value) {
        this.$emit('onChangePickupOrderItemsLimit', value);
      },
    },
    'editable.soldOutLimit': {
      deep: true,
      handler(value) {
        this.$emit('onChangeSoldOutLimit', value);
      },
    },
    'editable.orderSoonLimit': {
      deep: true,
      handler(value) {
        this.$emit('onChangeOrderSoonLimit', value);
      },
    },
  },
  methods: {
    regex(min, max) {
      return regex(min, max);
    },
  },
  data() {
    return {
      editable: {
        pickupOrderLimit: this.pickupOrderLimit,
        pickupOrderItemsLimit: this.pickupOrderItemsLimit,
        soldOutLimit: this.soldOutLimit,
        orderSoonLimit: this.orderSoonLimit,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.category {
  .info {
    text-align: left;
    margin-top: 6px;
    margin-left: 174px;
    font-size: 12px;
    color: #666;
  }

  .input {
    width: 100%;
    min-width: 150px;
    max-width: 350px;
  }
}

@media screen and (max-width: 1024px) {
  .category {
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;

    .info {
      margin-left: 0;
      width: 80%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/service/category/CommonServicePolicy.vue